import LinkButton, {
  Button as LinkButtonContainer,
} from "@components/buttons/LinkButton"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { smallcapsBold14Styles } from "@constants/typography"
import React from "react"
import styled from "styled-components"

const Container = styled.div<{ itemCount: number; lastItem: boolean }>`
  flex-direction: column;
  display: flex;
  z-index: 1;
  width: 100%;
  margin-right: ${(props) => (props.lastItem ? "0" : "10px")};

  @media ${breakpoints.tablet} {
    position: relative;
    width: ${(props) => `calc(100% / ${props.itemCount})`};
    max-width: calc(100% / 3);
    margin-right: ${(props) => (props.lastItem ? "0" : "22px")};
  }

  @media ${breakpoints.laptop} {
    position: relative;
    width: ${(props) => `calc(100% / ${props.itemCount})`};
    max-width: calc(100% / 3);
    margin-right: ${(props) => (props.lastItem ? "0" : "54px")};
  }
`

const ButtonWrapper = styled.div<{ active?: boolean }>`
  position: absolute;
  left: calc(0.5 / 12 * 100vw);
  right: calc(0.5 / 12 * 100vw);
  bottom: 0;
  width: calc(11 / 12 * 100vw);
  opacity: ${(props) => (props.active ? 1 : 0)};
  pointer-events: ${(props) => (props.active ? "initial" : "none")};
  ${({ active }) => active && "z-index: 1;"}

  @media ${breakpoints.tablet} {
    top: 9px;
    left: initial;
    right: initial;
    width: 100%;
  }

  @media ${breakpoints.laptop} {
    top: 9px;
    left: initial;
    right: initial;
    width: 100%;
  }

  ${LinkButtonContainer} {
    span {
      padding-right: 12px;
    }
  }
`

const ProgressContainer = styled.div`
  position: relative;
  width: 100%;
  height: 1px;
  overflow: hidden;
`

const ProgressBackground = styled.div`
  width: 100%;
  height: 100%;
  background: ${colors.offWhite};
  opacity: 0.5;
`

const ProgressBar = styled.div<{ active: boolean; progressDuration: number }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${colors.black};
  border-radius: 2px;
  will-change: transform;
  transition: transform
    ${(props) => (props.active ? props.progressDuration : 0)}s linear;
  transform: ${(props) =>
    props.active ? "translateX(0)" : "translateX(-100%)"};
  visibility: ${(props) => (props.active ? "visible" : "hidden")};
`

const TextWrapper = styled.div<{ active?: boolean }>`
  display: none;

  @media ${breakpoints.laptop} {
    display: block;
    margin-top: 22px;
    opacity: ${(props) => (props.active ? 0 : 1)};
  }
`

const Text = styled.div`
  ${smallcapsBold14Styles}
  color: ${colors.offWhite};
  text-shadow: 0px 2px 10px rgba(0, 0, 0, 0.05);
  cursor: pointer;
`

interface MediaCarouselItemProps {
  active?: boolean
  external?: boolean
  itemCount: number
  lastItem: boolean
  onClick: (event: any) => void
  progressDuration: number
  title: string
  to: string
}

const MediaCarouselItem = (props: MediaCarouselItemProps) => (
  <Container itemCount={props.itemCount} lastItem={props.lastItem}>
    <ButtonWrapper active={props.active}>
      <LinkButton external={props.external} text={props.title} to={props.to} />
    </ButtonWrapper>
    <ProgressContainer>
      <ProgressBackground />
      <ProgressBar
        active={props.active || false}
        progressDuration={props.progressDuration}
      />
    </ProgressContainer>
    <TextWrapper active={props.active}>
      <Text onClick={props.onClick}>{props.title}</Text>
    </TextWrapper>
  </Container>
)

export default MediaCarouselItem
